import React, { useState } from 'react';
import '../styles/pages/FAQ.scss';
import { useMsal } from '@azure/msal-react';
import useFetchWithMsal from '../hooks/useFetchWithMsal';
import { protectedResources } from '../authConfig';
import parse from 'html-react-parser';
import { Icon } from '../components/icons/icons';

const FAQ = () => {
  const { instance } = useMsal();
  const [account, setAccount] = useState(instance.getActiveAccount());
  const { error, execute } = useFetchWithMsal({
    scopes: protectedResources.apiCFSkillPath.scopes.read,
  });
  const [loading, setLoading] = useState(false);
  const [callErr, setErr] = useState(null);
  const [faqs, setFAQs] = useState<{ faqId: string; question: string; answer: string }[]>([]);

  const getFAQs = () => {
    let acc = account;
    setLoading(true);
    execute(
      "GET",
      `/api/FAQs`
    )
      .then((response) => {
        if (response.error) {
          return;
        }
        //setSLData(response);
        setFAQs(response);
        setLoading(false);
        //setOdataStringSt(odataString);
      })
      .catch((err) => {
        setErr(err);
        setLoading(false);
      });
  }
  if (!loading && faqs.length < 1) {
    getFAQs();
  }
  return <>

    <div className='core-container'>
      <div className='core-desktop-max-width'>
        <h2 className='fnt-wght-bold m-b-1 h1-size'>Frequently Asked Questions</h2>
      </div>
    </div>
    <div className='core-desktop-max-width padded'>
      <dl>
        {faqs.length > 0 && faqs.map((faq, index) => (
          <React.Fragment key={faq.faqId}>
            <dt>
              <Icon name="icon-chat-bullet" className='icon-black core-chat-bullet' />
              {(faq as any).question}
            </dt>
            <dd className='m-l--50'><blockquote>{parse((faq as any).answer)}</blockquote></dd>
          </React.Fragment>
        ))}
      </dl>
    </div>
  </>;
};

export default FAQ;